export default {"src":"https://images-cdn.curipod.com/d-8c53f8fc/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};